import { Button } from "@mui/material";
import Hero from "../../../shared/YasuLib/Hero/Hero";
import HeroContent from "../../../shared/YasuLib/Hero/HeroContent/HeroContent";
import HeroText from "../../../shared/YasuLib/Hero/HeroText/HeroText";
import HeroTitle from "../../../shared/YasuLib/Hero/HeroTitle/HeroTitle";
import MainContent from "../../../shared/YasuLib/MainContent/MainContent";
import "./Sinkhole.scss";
import bookImage from "../../../../assets/images/the-sinkhole-book.avif";
import PillButton from "../../../shared/YasuLib/PillButton/PillButton";
import NewsletterSection from "../../../shared/NewsletterSection/NewsletterSection";

const BOOK_LINK = "https://www.amazon.ca/dp/1067390804";

const Sinkhole = () => {
  return (
    <div className="w-full">
      <Hero className="HomeHero w-full">
        <HeroContent>
          <HeroTitle>Welcome to The Sinkhole</HeroTitle>
          <HeroText>
            The World of Yasu fuses a fantasy world with a real-life drink. Our heroine brews the very first Yasu drink
            in the Sinkhole itself for her own focus and energy. Enter <span className="italic">The Sinkhole</span>, a
            newly released fast-paced fantasy you won't want to put down.
          </HeroText>

          <PillButton
            href={BOOK_LINK}
            target="_blank"
            rel="noreferrer"
            className="max-sm:hidden max-sm:w-28 sm:w-44 rounded-3xl sm:h-12 !h-fit"
          >
            Order now
          </PillButton>
        </HeroContent>
      </Hero>
      <MainContent className="bg-midnightDark">
        <div className="max-w-5xl mx-auto">
          <div>
            <div className="hidden sm:block pt-24">
              <div className="h-2 w-1/3 bg-primary"></div>
            </div>
            <div className="grid grid-cols-1 sm:text-lg sm:grid-cols-5 grid-rows-[auto_1fr] gap-1 sm:gap-2">
              {/* Column 1 */}
              <div className="max-sm:order-1 sm:col-start-1 sm:col-span-3 sm:row-start-1">
                <h2 className="max-sm:pt-12 max-sm:flex max-sm:justify-center max-sm:mt-0 sm:mb-0 text-xl sm:text-4xl font-bold font-fraunces">
                  Dive into the Sinkhole
                </h2>
              </div>
              <div className="max-sm:pt-12 max-sm:order-4 sm:col-start-1 sm:col-span-3 sm:hidden">
                <h2 className="text-xl sm:text-4xl font-bold font-fraunces">About The Sinkhole</h2>
              </div>
              <div className="max-sm:order-5 sm:col-start-1 sm:col-span-3 sm:row-start-2">
                <p>
                  Getting to the Sinkhole is just the first part. Surviving it, with smoke creeping into every inch, is
                  another.
                </p>
                <p>
                  Evelina wanted to move on, but instead, she was pulled somewhere else entirely. It's a place of
                  beauty, danger, and unspoken rules. The forests breathe. The skies look alive. But something dangerous
                  is stirring beneath it all.
                </p>
                <p>
                  Welcome to the Sinkhole, where the academy trains you to survive the ruthless smoke, your community
                  acts as your anchor of support, and survival means mastering more than just your instincts. And when
                  the smoke clears, so will the version of you that walked in.
                </p>
              </div>
              <div className="flex max-sm:justify-center max-sm:pt-4 max-sm:order-3 sm:col-start-1 sm:col-span-3 sm:row-start-3">
                <Button
                  variant="contained"
                  className={`max-sm:w-28 sm:w-44 rounded-2xl p-2 text-xs sm:text-sm md:text-lg md:font-bold capitalize border-solid border-2 border-primary bg-primary hover:bg-transparent max-sm:h-8`}
                  target="_blank"
                  rel="noreferrer"
                  href={BOOK_LINK}
                >
                  Order now
                </Button>
              </div>

              {/* Column 2 */}
              <div className="max-sm:order-2 sm:col-start-4 sm:col-span-2 sm:row-span-3 flex items-center justify-center">
                <img className="max-sm:max-w-xs w-full" src={bookImage} alt="The Sinkhole Book" />
              </div>
            </div>
          </div>
          <div className="py-12 sm:px-18 text-center">
            <h2 className="text-xl sm:text-4xl font-bold font-fraunces"> Released Story Artwork</h2>
            <iframe
              className="w-full h-full max-w-2xl aspect-video"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/x9GJmn1WQB8?si=XNF6i7YMIYYszaFU"
              title="YouTube video player"
              frameBorder={0}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
          <div className="sm:text-lg space-y-8">
            <h2 className="text-xl sm:text-4xl font-bold font-fraunces">Immerse Yourself</h2>
            <p>
              In the Sinkhole, you can hear whispers of unseen creatures echoing through the caverns, rivers, and
              tunnels. The air is crisp, with the warm smell of honey, vanilla, and freshly baked sweets floating out of
              the market. Ingredients, spices, and herbs can be found here to rejuvenate your senses and ignite the
              imagination.
            </p>
            <p>
              The Sinkhole is home to the Vishalda community, one of the four unique communities nestled within the
              realm of Yasu. At the heart of the Sinkhole lies one of its many brilliant quarters, the Charm Closet, a
              vibrant and bustling suburb bursting with color and life. Here, artisans display their talents, crafting
              fashion pieces, defensive garments, and items that enhance movement, ease pain, or even deepen one's
              breath. The shelves are stocked with an eclectic array of materials, each more exotic and fantastical than
              the last, offering endless possibilities for innovation and expression.
            </p>
            <p>
              It's also home to many classes readers love and adore, including: Science, Alchemy, Defensive Combat,
              Intelligence, and more.
            </p>
          </div>
        </div>
        <div className="max-w-7xl m-auto" id="newsletter">
          <NewsletterSection
            heading="Follow The Sinkhole"
            text="Join our email list for exclusive monthly updates on drink launches, environment artwork, discoveries and more. "
          />
        </div>
      </MainContent>
    </div>
  );
};

export default Sinkhole;
